// Values injected at build time by `define` in vite.config.ts.
// __BUILD_VERSION__ is the release tag (`v0.12.0`) when promote-frontend.yml
// built this bundle, and null for local / preview builds — see vite.config.ts.
// __BUILD_SHA__ is a short SHA (or `<short>-dirty` from `git describe`).
// __BUILD_TIME__ is ISO-8601 UTC.
export const BUILD_INFO = {
  version: __BUILD_VERSION__,
  sha: __BUILD_SHA__,
  builtAt: __BUILD_TIME__,
} as const;

// Release when CI built it (`v0.12.0 (0d72fdb)`), bare SHA otherwise
// (`0d72fdb`, `0d72fdb-dirty`). A dev build never wears a version it did not earn.
export function formatBuildLabel(): string {
  return BUILD_INFO.version ? `${BUILD_INFO.version} (${BUILD_INFO.sha})` : BUILD_INFO.sha;
}

export function formatBuildTooltip(): string {
  return `Built ${BUILD_INFO.builtAt}`;
}
